<form [formGroup]="form" (ngSubmit)="trigger(true)">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'dev.translator.edit.entry' | translate: { key: key } }}
    </h4>

    <button class="btn-close" (click)="trigger(false)" aria-label="Close" type="button"></button>
  </div>

  <div class="bootstrap-validation-background--hidden modal-body">
    <div class="d-flex justify-content-end mb-2">
      <!-- Switch to Default -->
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          id="modeDefault"
          formControlName="mode"
          type="radio"
          value="default"
        />
        <label class="form-check-label" for="modeDefault">
          {{ 'translations.mode.default' | translate }}
        </label>
      </div>

      <!-- Switch to specific -->
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          id="modeSpecific"
          formControlName="mode"
          type="radio"
          value="specific"
        />
        <label class="form-check-label" for="modeSpecific">
          {{ 'translations.mode.specific' | translate }}
        </label>
      </div>
    </div>

    <div [class]="{ 'd-none': form.value.mode === 'default' }" formArrayName="overrides">
      @for (translation of formOverrides.controls; track translation; let index = $index) {
        <div class="form-group" [formGroupName]="index">
          <div class="d-flex justify-content-between mb-1">
            <label class="text-truncate" [for]="'specific_' + translation.value.key + 'value'">
              {{ translation.value.key }}
            </label>
            <portal-inheritable-input
              [inactiveValue]="originalValues[translation.value.key]"
              formControlName="value"
            ></portal-inheritable-input>
          </div>
          <textarea
            class="form-control"
            [id]="'specific_' + translation.value.key + 'value'"
            (keydown.control.enter)="trigger(true)"
            formControlName="value"
            rows="3"
            type="text"
          ></textarea>
        </div>
      }
    </div>

    <div [class]="{ 'd-none': form.value.mode === 'specific' }" formArrayName="translations">
      @for (translation of formTranslations.controls; track translation; let index = $index) {
        <div class="form-group" [formGroupName]="index">
          <label class="text-truncate" [for]="'default_' + translation.value.key + 'value'">
            {{ translation.value.key }}
          </label>
          <textarea
            class="form-control"
            [id]="'default_' + translation.value.key + 'value'"
            (keydown.control.enter)="trigger(true)"
            formControlName="value"
            rows="3"
            type="text"
          ></textarea>
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-default" (click)="trigger(false)" type="button">
      <i class="far fa-times fa-fw"></i>
      <span>
        {{ 'button.cancel' | translate }}
      </span>
    </button>
    <portal-save-button
      [invalid]="form.invalid"
      [pristine]="form.pristine"
      [state]="saving"
      (save)="trigger(true)"
    >
    </portal-save-button>
  </div>
</form>
